export enum APP_ERROR_CODE {
    // 方法未实现
    METHOD_NOT_FOUND = '000002'
}

/** 桌面快捷入口公共协议 */
export type HeaderPosition = 'left' | 'right';

export interface HeaderAction {
    id: string;
    icon: 'more';
    enabled?: boolean;
}

export interface SetHeaderActionsParams {
    /** 默认右侧；首版传 left 返回 610002，不静默忽略。 */
    position?: HeaderPosition;
    /** 覆盖该侧业务按钮；空数组清空，重复 ID 保留第一个。 */
    actions: HeaderAction[];
}

export interface ClearHeaderActionsParams {
    /** 默认 ['right']；空数组为空操作，包含 left 时整体拒绝。 */
    positions?: HeaderPosition[];
}

export interface HeaderActionClickEvent {
    position: HeaderPosition;
    id: string;
}

export interface AddToDesktopParams {
    /** H5 生成的稳定标识；App 不解析其身份或业务含义。 */
    id: string;
    name: string;
    /** 可匿名访问的 HTTPS PNG 地址，不附加 App 认证头。 */
    iconUrl: string;
    /** 完整业务 HTTPS URL，包含 tenant_id 企业上下文。 */
    url: string;
    /** 只在 iOS 必填；基础地址，不是已经拼好入口参数的链接。 */
    ios?: { guideUrl: string };
}

export type AddToDesktopResult =
    | { platform: 'android'; status: 'requested' }
    | { platform: 'ios'; status: 'guideOpened' };
